<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.conversation"
                    label="Conversación"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.conversation"
                    :background-color="showErrors && !stage.conversation ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <h3>Representación documento:</h3>
        </v-row>
        <v-row>
            <col cols="12">
                <v-radio-group v-model="stage.input_mode" @change="computeStage" row>
                    <v-radio label="Modo PDF" value="pdf"></v-radio>
                    <v-radio label="Modo imagen" value="image"></v-radio>
                    <v-radio label="Texto" value="text"></v-radio>
                    <v-radio label="Ruta" value="media_path"></v-radio>
                    <v-radio label="Ninguna" value="none"></v-radio>
                </v-radio-group>
            </col>
        </v-row>
        <v-row v-if="stage.input_mode === 'image' || stage.input_mode === 'pdf'">
            
            <v-col cols="2" v-if="stage.input_mode === 'image'">
                <v-text-field v-model="stage.headPages" label="Primeras n páginas" type="number"></v-text-field>
            </v-col>
            <v-col cols="2" v-if="stage.input_mode === 'image'">
                <v-text-field v-model="stage.tailPages" label="Últimas n páginas " type="number"></v-text-field>
            </v-col>
            <v-col cols="2">
                <v-checkbox
                    v-model="stage.crop"
                    label="Crop"
                    hide-details
                    @change="computeStage"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row v-if="stage.input_mode === 'media_path'">
            <v-col cols="4">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ruta (path): </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.media_path"
                    :my_bag="my_bag"
                    outlined></RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row v-if="stage.input_mode === 'text'">
            <v-col cols="2">
                <v-select 
                    v-model="stage.textFormat"
                    :items="[{'text': 'Texto plano', 'value': 'plain_text'}, {'text': 'LMDX', 'value': 'lmdx'}, {'text': 'Renderizado', 'value': 'rendered'}]"
                    value="value"
                    label="Formato de texto"
                ></v-select>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { AddDocumentRepresentationToConversation } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from "@/modules/document/infra/RouteInBagSelectorComponent";

export default {
    name:'AddDocumentRepresentationToConversationDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: AddDocumentRepresentationToConversation,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return {
            show_custom_prompt: true
        }
    },
    mounted(){
        console.log(this.stage);
        // this.cssLink = document.createElement('link');
        // this.cssLink.rel = 'stylesheet';
        // this.cssLink.href = 'https://unpkg.com/json-schema-editor-vue/lib/json-schema-editor-vue.css';
        // document.head.appendChild(this.cssLink);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        computeStage(){
            this.$emit('compute-stage');
        }
    },
    computed:{
        
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>